(ns hypnos.sleeplab.tile.field.consult-modality
  "Field the modality."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal
     [:label.label (tr :ui.label/modality)]]
    [:div.field-body
     [:div.field.is-narrow
      [:div.control
       [:div.select.is-fullwidth
        [:select
         {:value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/modality :value])]
                       (name val)
                       "")
          :disabled  disabled
          :on-change (fn [e]
                       (let [old-value (get-in @state [:patient :patient/last-consult :consult/modality :value])
                             new-value (keyword (str "modality/" (-> e .-target .-value)))
                             changed?  (or (get-in @state [:patient :patient/last-consult :consult/modality :dirty?])
                                           (not= new-value old-value))]
                         (swap! state assoc-in [:patient :patient/last-consult :consult/modality :value] new-value)
                         (swap! state assoc-in [:patient :patient/last-consult :consult/modality :dirty?] changed?)
                         ;; clear depended values
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/cpap]
                                {:value nil :dirty? false :touched? false})
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/ipap]
                                {:value nil :dirty? false :touched? false})
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/epap]
                                {:value nil :dirty? false :touched? false})))
          :on-focus  (fn [_]
                       (swap! state assoc-in
                              [:patient :patient/last-consult :consult/modality :touched?]
                              true))}
         [:option {:key "unknown" :value "unknown"} (tr :ui.modality/unknown)]
         [:option {:key "cpap" :value "cpap"} (tr :ui.modality/cpap)]
         [:option {:key "autopap-smartpap" :value "autopap-smartpap"} (tr :ui.modality/autopap-smartpap)]
         [:option {:key "bipap-vpap" :value "bipap-vpap"} (tr :ui.modality/bipap-vpap)]]]]]]]))
